// Global Instructions Rule Applied!
import { getTabModuleForSearchEntityType } from '../../../config/globalSearch.ts'

/** Mobile-only route paths. Detail views reuse the desktop deep-link shape (below). */
export const MOBILE_ROUTES = {
  home: '/home',
  browse: '/browse',
  search: '/search',
  account: '/account'
} as const

/** Browse-list path for a module (the read-only mobile grid). */
export function browsePath(module: string): string {
  return `/browse/${module}`
}

/**
 * Detail deep-link path for a record. Mirrors the desktop URL shape parsed by
 * `useTabManager` (`/{module}/forms/full/{id}`), so the same link opens the same
 * record on a phone or on the desktop, and a breakpoint flip keeps you in place.
 */
export function detailPath(module: string, id: string | number): string {
  return `/${module}/forms/full/${id}`
}

/** Detail path for a global-search result row (maps `entity_type` → route module). */
export function detailPathForSearchResult(entityType: string, entityId: string): string | null {
  const module = getTabModuleForSearchEntityType(entityType)
  if (!module || !entityId) return null
  return detailPath(module, entityId)
}

/** Two-letter initials for an avatar fallback (mirrors NavbarSearch). */
export function avatarInitials(label?: string | null): string {
  if (!label) return '??'
  const parts = String(label).trim().split(/\s+/)
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  return String(label).substring(0, 2).toUpperCase()
}
